module.exports = __webpack_public_path__ + "static/media/kubernetes-k3s.0f064a95.svg";